module.exports = __webpack_public_path__ + "img/pro_12.2145600e.jpg";